/**
 * GenieDisc — brand radial mascot disc. Wraps the repo's animated `GenieAvatar`
 * in a soft brand-tinted circle. Used by gallery, hub, owner and onboarding.
 *
 * Sizes: 64 / 90 / 104 / 132 / 156 (named so callers stay consistent).
 */
import type { CSSProperties } from "react";
import { GenieAvatar } from "@/components/GenieAvatar";

export type GenieDiscSize = 64 | 90 | 104 | 132 | 156;

interface GenieDiscProps {
  size?: GenieDiscSize;
  /** Brand colour for the avatar glow (defaults to genie-primary) */
  color?: string;
  /** Optional secondary colour for a gradient avatar */
  secondaryColor?: string | null;
  gradientEnabled?: boolean;
  /** Optional custom avatar image (e.g. a real genie's avatar_url) */
  customAvatarUrl?: string | null;
  className?: string;
  style?: CSSProperties;
}

export const GenieDisc = ({
  size = 104,
  color = "#4E9CFF",
  secondaryColor = "#FF4DB8",
  gradientEnabled = true,
  customAvatarUrl = null,
  className,
  style,
}: GenieDiscProps) => {
  return (
    <div className={className} style={{ width: size, height: size, ...style }}>
      <GenieAvatar
        size={size}
        color={color}
        secondaryColor={secondaryColor}
        gradientEnabled={gradientEnabled}
        gradientAngle={135}
        customAvatarUrl={customAvatarUrl}
      />
    </div>
  );
};

export default GenieDisc;
